import React, { useState } from 'react';
import styles from './GlobalTextarea.module.css';

interface GlobalTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
  className?: string;
}

export const GlobalTextarea: React.FC<GlobalTextareaProps> = ({
  label,
  error,
  className,
  value,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  // Compute hasValue from the value prop to handle initial values correctly
  const hasValue =
    value !== undefined && value !== null
      ? String(value).length > 0
      : false;

  const handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    setIsFocused(true);
    props.onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    setIsFocused(false);
    props.onBlur?.(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange?.(e);
  };

  return (
    <div className={`${styles?.inputContainer ?? ''} ${className ?? ''}`}>
      <div className={styles?.inputWrapper ?? ''}>
        <textarea
          {...props}
          value={value}
          className={[
            styles?.textarea,
            styles?.input,
            error ? styles?.error : '',
            isFocused ? styles?.focused : '',
            hasValue ? styles?.hasValue : '',
          ].filter(Boolean).join(' ')}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder=" "
        />
        <label className={styles?.label ?? ''}>{label}</label>
      </div>
      {error && <span className={styles?.errorMessage ?? ''}>{error}</span>}
    </div>
  );
};